export enum EnrollmentStatus {
    NotEnrolled,
    PaymentPending,
    Enrolled
  }
  